module.exports = __webpack_public_path__ + "assets/img/23_126_big.b35a6236.jpg";